































































import VueOptions from '@utils/VueOptions'
import DropdownFilter from '@ui/Filters/DropdownFilter'

settings =
  name: 'AudienceCreativeFilter'

  vue:
    props: ['target', 'actions', 'options']

    components: {
      DropdownFilter,
    }

    data: ->
      selectedStatus: null
      selectedIndicatorKey: null

    mounted: ->
      @initializeSelectedFilters()

    computed:
      defaultStatus: -> null
      targetStatus: -> @target.status
      labelForStatusFilter: ->
        label = @optionsForStatusFilter[@targetStatus] if @targetStatus
        label ||= 'State'
        label

      optionsForStatusFilter: ->
        { '': 'All', ...@trustedOptionsForStatusFilter, ...@untrustedOptionsForStatusFilter }
      trustedOptionsForStatusFilter: ->
        available: 'Available'
        unavailable: 'Unavailable'
      untrustedOptionsForStatusFilter: ->
        missing: 'Missing'
        unknown: 'Unknown'
        unconfirmed: 'Unconfirmed'


      defaultIndicatorKey: -> null
      targetIndicatorKey: -> @target.indicator_key
      labelForIndicatorKeyFilter: ->
        label = @optionsForIndicatorKeyFilter[@targetIndicatorKey] if @targetIndicatorKey
        label ||= 'Type'
        label

      optionsForIndicatorKeyFilter: ->
        {
          '': 'All',
          ...@supplierOptionsForIndicatorKeyFilter,
          ...@organizerOptionsForIndicatorKeyFilter,
          ...@creativeOptionsForIndicatorKeyFilter,
          ...@venueOptionsForIndicatorKeyFilter,
          ...@availabilityOptionsForIndicatorKeyFilter
        }
      supplierOptionsForIndicatorKeyFilter: ->
        website: 'Website'
        national_omnichannel: 'Omni National'
      organizerOptionsForIndicatorKeyFilter: ->
        min_payout: 'Min Payout'
      creativeOptionsForIndicatorKeyFilter: ->
        sampling_asset: 'Sampling Asset'
        onsite_asset: 'Onsite Asset'
      venueOptionsForIndicatorKeyFilter: ->
        shipping_area: 'Shipping Area'
        signage: 'Signage'
        printer: 'Printer'
        pullup_banner: 'Pullup Banner'
        cold_storage: 'Cold Storage'
        frozen_storage: 'Frozen Storage'
        pallet_delivery: 'Pallet Delivery'
      availabilityOptionsForIndicatorKeyFilter: ->
        omni_local: 'Omni Local'
        dates_confirmed: 'Dates Confirmed'
        social_boost: 'Social Boost'

    methods:
      initializeSelectedFilters: ->
        @selectedStatus = @targetStatus
        @selectedIndicatorKey = @targetIndicatorKey

      hiApplyFilters: ->
        @target.status = @selectedStatus
        @target.indicator_key = @selectedIndicatorKey
        @actions.hiApplyFilters()

      hiClearStatusFilter: ->
        @target.status = @defaultStatus
        @initializeSelectedFilters()
        @actions.hiApplyFilters()

      hiClearIndicatorKeyFilter: ->
        @target.indicator_key = @defaultIndicatorKey
        @initializeSelectedFilters()
        @actions.hiApplyFilters()

export default VueOptions.vue settings
